import PrintShell, { PrintField, PrintSectionHeader, PrintTextBlock } from '../../../components/print/PrintShell';

export default function CarrouselPrintTemplate({ carrousel: c }) {
  if (!c) return null;
  return (
    <PrintShell printClass="carrousel-print-only" formTitle="CARROUSEL SLIDE">
      <PrintSectionHeader title="Slide" />
      <PrintField label="Title" value={c.title} />
      <PrintTextBlock label="Description" value={c.body} />
      <PrintField label="Image" value={c.picture} />
    </PrintShell>
  );
}
